var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38540",
    "data-name": "Group 38540",
    transform: "translate(0.498)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(-0.498)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    transform: "translate(4.902 4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4125-2",
    "data-name": "Group 4125",
    transform: "translate(0 0.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M94.638,558.8H87.994a.244.244,0,0,1-.244-.244v-1.172a.636.636,0,0,1,.635-.635h5.863a.636.636,0,0,1,.635.635v1.172A.244.244,0,0,1,94.638,558.8Zm-6.4-.489h6.156v-.928a.147.147,0,0,0-.147-.147H88.385a.147.147,0,0,0-.147.147Z",
    transform: "translate(-87.75 -556.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(0.391 2.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M95.466,570.906H90.385a.636.636,0,0,1-.635-.635v-5.276a.244.244,0,0,1,.244-.244h5.863a.244.244,0,0,1,.244.244v5.276A.636.636,0,0,1,95.466,570.906Zm-5.227-5.667v5.032a.147.147,0,0,0,.147.147h5.081a.147.147,0,0,0,.147-.147v-5.032Z",
    transform: "translate(-89.75 -564.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(2.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M101.948,553.216H99.994a.244.244,0,0,1-.244-.244v-.586a.636.636,0,0,1,.635-.635h1.173a.636.636,0,0,1,.635.635v.586A.244.244,0,0,1,101.948,553.216Zm-1.71-.489H101.7v-.342a.147.147,0,0,0-.147-.147h-1.173a.147.147,0,0,0-.147.147Z",
    transform: "translate(-99.75 -551.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(1.954 3.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1483",
    "data-name": "Rectangle 1483",
    width: 0.489,
    height: 3.713,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129",
    transform: "translate(3.322 3.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 0.489,
    height: 3.713,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4130",
    "data-name": "Group 4130",
    transform: "translate(4.69 3.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 0.489,
    height: 3.713,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationDeleteIcon);
export default __webpack_public_path__ + "static/media/verification-delete-icon.6f6acb427cf5a07cedba1702ae358577.svg";
export { ForwardRef as ReactComponent };